mustEndAbs